import React from 'react';
import AppHeader from '../components/AppHeader.js';
import clipboard from '../utils/clipboard.js';

const getPriceRows = (usrInfo) => [
	{
		label: 'Jednorázový',
		value: `${usrInfo.ENTRY_PRICE_ONE}`
	},
	{
		label: '1 týden',
		value: `${usrInfo.ENTRY_PRICE_WEEK1}`
	},
	{
		label: '2 týdny',
		value: `${usrInfo.ENTRY_PRICE_WEEK2}`
	},
	{
		label: '1 měsíc',
		value: `${usrInfo.ENTRY_PRICE_MONTH1}`
	},
	{
		label: '2 měsíce',
		value: `${usrInfo.ENTRY_PRICE_MONTH2}`
	},
	{
		label: '3 měsíce',
		value: `${usrInfo.ENTRY_PRICE_MONTH3}`
	}
];

export default function Pay({usrInfo, timerCnt}) {
	const accountNumber = '2003123267/2010';
	const iban = 'CZ8420100000002003123267';
	const priceRows = getPriceRows(usrInfo);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={false} />

				<div className={`page pay-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="pay-page__shell">
						<section className="pay-page__section pay-page__section--payment">
							<div className="pay-page__section-head">
								<h2 className="pay-page__section-title">Platba</h2>
							</div>
							<div className="pay-page__payment-grid">
								<button type="button" className="pay-page__qr-card" onClick={() => clipboard(accountNumber)}>
									<img className="pay_qr" alt="QR platba" />
								</button>
								<div className="pay-page__payment-details">
									<div className="pay-page__payment-card">
										<div className="pay-page__payment-label">Číslo účtu</div>
										<button type="button" className="pay-page__payment-value" onClick={() => clipboard(accountNumber)}>
											{accountNumber}
										</button>
										<button type="button" className="button pay-page__button" onClick={() => clipboard(accountNumber)}>
											Zkopírovat číslo účtu
										</button>
									</div>

									<div className="pay-page__payment-card">
										<div className="pay-page__payment-label">IBAN</div>
										<button type="button" className="pay-page__payment-value" onClick={() => clipboard(iban)}>
											{iban}
										</button>
										<button type="button" className="button pay-page__button" onClick={() => clipboard(iban)}>
											Zkopírovat IBAN
										</button>
									</div>
								</div>
							</div>
						</section>

						<section className="pay-page__section">
							<div className="pay-page__section-head">
								<h2 className="pay-page__section-title">Informace k platbě</h2>
							</div>
							<div className="pay-page__notes">
								<div className="pay-page__note">
									Při platbě zadejte částku dle ceníku níže. Délka členství vám bude prodloužena podle zaslané částky ode dne přijetí platby. Pokud možno tak použijte okamžitou platbu.
								</div>
								<div className="pay-page__note">
									Je možné si předplatit jednorázové vstupy. Toto uveďte do poznámky k platbě.
								</div>
							</div>
						</section>

						<section className="pay-page__section">
							<div className="pay-page__section-head">
								<h2 className="pay-page__section-title">Ceník</h2>
							</div>
							<div className="pay-page__price-table" role="table" aria-label="Ceník vstupů">
								<div className="pay-page__price-row pay-page__price-row--head" role="row">
									<div className="pay-page__price-cell" role="columnheader">Vstup</div>
									<div className="pay-page__price-cell pay-page__price-cell--value" role="columnheader">Cena</div>
								</div>
								{priceRows.map((priceRow) => (
									<div key={priceRow.label} className="pay-page__price-row" role="row">
										<div className="pay-page__price-cell" role="cell">{priceRow.label}</div>
										<div className="pay-page__price-cell pay-page__price-cell--value" role="cell">{priceRow.value}</div>
									</div>
								))}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
